angular.module('impactx.address').directive('appAddress', [function() {
    return {
        scope: {
            data: '=',
            addressSize: '@'
        },
        restrict: 'E',
        templateUrl: function(elem, attr) {
            if(attr.addressSize != null || attr.addressSize != undefined) {
                return 'modules/address/templates/address-' + attr.addressSize + '.html'
            }
            else {
                // return basic size of address dialog as default if no type is given
                return 'modules/address/templates/address-basic.html'
            }
        },
        controller: 'AddressDirectiveCtrl',
        controllerAs: 'ctrl',
        transclude: true
    };
}]);
